import {
  Policy,
  PolicyExpenseLimits,
  PolicyRule,
  StandardType
} from 'src/types'

function id(id: number | string | undefined = null) {
  if (id === '') {
    return null
  }

  if (id === '0') {
    return 0
  }

  return +id || null
}

function policyExpenseLimitsReduce(
  acc: PolicyExpenseLimits[],
  cur: PolicyExpenseLimits
) {
  const isNewLimit = typeof cur.policy_expense_limit_id === 'string'
  if (isNewLimit && !cur.active) {
    return acc
  }

  const isKmService = cur.service?.standard_type === StandardType.KM
  delete cur.currency
  delete cur.reason
  delete cur.reference
  delete cur.service

  if (isNewLimit) {
    cur.policy_expense_limit_id = null
  }

  if (!isKmService) {
    cur.value = 0
  }

  return [
    ...acc,
    {
      ...cur,
      currency_id: id(cur.currency_id),
      policy_expense_limit_id: id(cur.policy_expense_limit_id),
      policy_id: id(cur.policy_id),
      reason_id: id(cur.reason_id),
      reference_id: id(cur.reference_id),
      service_id: id(cur.service_id)
    }
  ]
}

function policyRulesReduce(acc: PolicyRule[], cur: PolicyRule): PolicyRule[] {
  delete cur.reason

  // policy_request_general_rule
  if (cur.policy_request_general_rule?.policy_request_general_rule_id) {
    cur.policy_request_general_rule.policy_request_general_rule_id = id(
      cur.policy_request_general_rule?.policy_request_general_rule_id
    )
    cur.policy_request_general_rule.policy_rule_id = id(
      cur.policy_request_general_rule?.policy_rule_id
    )
  }

  // policy_request_air_rule
  if (cur.policy_request_air_rule?.policy_request_air_rule_id) {
    cur.policy_request_air_rule.policy_request_air_rule_id = id(
      cur.policy_request_air_rule.policy_request_air_rule_id
    )
    cur.policy_request_air_rule.policy_rule_id = id(
      cur.policy_request_air_rule.policy_rule_id
    )
    if (!cur.enable_flight) {
      cur.policy_request_air_rule.active = false
    }
  }

  // policy_request_hotel_rule
  if (cur.policy_request_hotel_rule?.policy_request_hotel_rule_id) {
    cur.policy_request_hotel_rule.policy_request_hotel_rule_id = id(
      cur.policy_request_hotel_rule.policy_request_hotel_rule_id
    )
    cur.policy_request_hotel_rule.policy_rule_id = id(
      cur.policy_request_hotel_rule.policy_rule_id
    )
    if (!cur.enable_hotel) {
      cur.policy_request_hotel_rule.active = false
    }
  }

  // policy_request_vehicle_rule
  if (cur.policy_request_vehicle_rule?.policy_request_vehicle_rule_id) {
    cur.policy_request_vehicle_rule.policy_request_vehicle_rule_id = id(
      cur.policy_request_vehicle_rule.policy_request_vehicle_rule_id
    )
    cur.policy_request_vehicle_rule.policy_rule_id = id(
      cur.policy_request_vehicle_rule.policy_rule_id
    )
    if (!cur.enable_vehicle_rent) {
      cur.policy_request_vehicle_rule.active = false
    }
  }

  // policy_receipt_rules
  if (cur.policy_receipt_rules?.length) {
    if (cur.policy_receipt_rules?.length) {
      cur.policy_receipt_rules = cur.policy_receipt_rules.map(poReRu => {
        delete poReRu.currency
        delete poReRu.reason
        delete poReRu.reference
        delete poReRu.service
        return {
          ...poReRu,
          currency_id: id(poReRu.currency_id),
          policy_receipt_rule_id: id(poReRu.policy_receipt_rule_id),
          reason_id: id(poReRu.reason_id),
          reference_id: id(poReRu.reference_id),
          service_id: id(poReRu.service_id)
        }
      })
    }
  }

  // policy_request_budget_rule
  delete cur.policy_request_budget_rule

  return [
    ...acc,
    {
      ...cur,
      policy_id: id(cur.policy_id),
      policy_rule_id: id(cur.policy_rule_id),
      reason_id: id(cur.reason_id)
    }
  ]
}

export function sanitizeToPost(values: Policy): Policy {
  const payload = JSON.parse(JSON.stringify(values))
  delete payload.tmp_reason_id
  return {
    ...payload,
    organization_id: id(payload.organization_id),
    policy_expense_limits: payload.policy_expense_limits.reduce(
      policyExpenseLimitsReduce,
      []
    ),
    policy_id: id(payload.policy_id),
    policy_rules: payload.policy_rules.reduce(policyRulesReduce, [])
  }
}
